module.exports = __webpack_public_path__ + "1e4fb86c86ed3a10c6e433a4b784fa52.png";